import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 12000,
});

export async function getStages(stageType) {
  try {
    const { data } = await api.get("/stages", { params: stageType ? { type: stageType } : {} });
    if (Array.isArray(data)) return data;
  } catch (e) {
    // API injoignable : liste vide
  }
  return [];
}

export async function getStage(slug) {
  try {
    const { data } = await api.get(`/stages/${slug}`);
    return data;
  } catch (e) {
    return null;
  }
}

export async function getCategories() {
  try {
    const { data } = await api.get("/categories");
    if (Array.isArray(data?.categories)) return data.categories;
  } catch (e) {
    // fallback ci-dessous
  }
  return Array.from({ length: 13 }, (_, i) => `U${i + 6}`);
}

export async function getGallery(type) {
  try {
    const { data } = await api.get("/gallery", { params: type ? { type } : {} });
    if (Array.isArray(data)) return data; // une galerie vide est un état valide
  } catch (e) {
    // API injoignable : galerie vide
  }
  return [];
}

export async function getSponsors() {
  try {
    const { data } = await api.get("/sponsors");
    if (Array.isArray(data)) return data;
  } catch (e) {
    // API injoignable : liste vide
  }
  return [];
}

export async function getClubs() {
  try {
    const { data } = await api.get("/clubs");
    if (Array.isArray(data)) return data;
  } catch (e) {
    // API injoignable : liste vide
  }
  return [];
}

export async function sendContactMessage(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export default api;

const apiError = (e, fallback) =>
  new Error(e.response?.data?.detail || fallback);

export async function getRegistrationAvailability(slug) {
  const { data } = await api.get(`/registrations/check/${slug}`);
  return data;
}

export async function createRegistration(payload) {
  try {
    const { data } = await api.post("/registrations", payload);
    return data;
  } catch (e) {
    throw apiError(e, "Une erreur est survenue lors de l'inscription.");
  }
}

export async function createCheckoutSession(registrationId) {
  try {
    const { data } = await api.post("/payments/checkout-session", {
      registration_id: registrationId,
      origin_url: window.location.origin,
    });
    return data;
  } catch (e) {
    throw apiError(e, "Impossible de créer la session de paiement.");
  }
}

export async function getRegistrationStatus(registrationId) {
  const { data } = await api.get(`/registrations/${registrationId}/status`);
  return data;
}
